import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class NotificationCentreService {
  getNotifications = async (payload) => {
    let url = `${Constants.NOTIFICATION_CENTRE}?`;
    if (payload) url += `org_id=${payload}&`;
    const notify = await Helpers.get({ url });
    return notify;
  }

  updateNotifications = async (payload) => {
    const notifyUpdate = await Helpers.post({
      url: Constants.NOTIFICATION_CENTRE,
      data: payload,
    });
    return notifyUpdate;
  }
}
export default new NotificationCentreService();
